import { CurrentClassSchedule } from "./CurrentClass";
import { DaySchedule } from "./DaySchedule/DaySchedule";

export const Schedule = ()=>(
  <div className={`w-full h-full flex flex-col gap-1`}>
  <CurrentClassSchedule />
  <DaySchedule />
  </div>
)